import React from "react";
import SectionCardSkeleton from "./SectionCardSkeleton";

const LearningPathwayContainerSkeleton: React.FC = () => {
  return (
    <div className="d-grid mt-4">
      <div className="section-card-container learningPathways">
        <SectionCardSkeleton />
        <SectionCardSkeleton />
        <SectionCardSkeleton />
        <SectionCardSkeleton />
        <SectionCardSkeleton />
        <SectionCardSkeleton />
      </div>
    </div>
  );
};

export default LearningPathwayContainerSkeleton;
